import { render, staticRenderFns } from "./ObjectCard.vue?vue&type=template&id=46eb7c7b"
import script from "./ObjectCard.vue?vue&type=script&lang=js"
export * from "./ObjectCard.vue?vue&type=script&lang=js"
import style0 from "./ObjectCard.vue?vue&type=style&index=0&id=46eb7c7b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports